import download from '@/plugins/excel/index';
import {getOrderList} from '@/api/workflow';
import {getPrivateCustome, myPublicCustomeList, getInvalidList, getBlackList, downloadCaculate} from '@/api/custome';
import {Message} from 'element-ui';
import {fmoney, parseTime} from '@/utils/index';
import { Loading } from 'element-ui'
import defaultSetting from '@/setting/index';

let loadingInstance = null;
const actions = {
  // 订单列表导出
  orderExport ({dispatch}, argument) {
    const {condition, tHeader, name, filterVal} = argument;
    download(condition, async (params, cb) => {
      try {
        const res = await getOrderList(params);
        if (!res.data || res.data.length <= 0) {
          Message.error('没有可导出的数据');
          return null;
        };
        const formatJson = (res.data || []).map(v => filterVal.map(j => {
          let value = v[j];
          if (['subscription_amount', 'room_total_amount', 'brokerage', 'discount_amount'].indexOf(j) >= 0) {
            value = fmoney(value, 0);
          }
          if (['latest_follow_up_time', 'created_at'].indexOf(j) >= 0) {
            value = parseTime(value, '{y}-{m}-{d} {h}:{i}');
          }
          return value;
        }))
        cb(formatJson, res.total);
        dispatch('downloadOprate', {type: 'order', params});
      } catch (error) {
        Message.error(error.msg || '导出列表出现错误');
      }
    }, {
      tHeader,
      name
    });
  },
  // 客户列表导出
  customerExport ({dispatch}, argument) { 
    const {condition, tHeader, name, filterVal, type, isLoading} = argument;
    loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
      text: '正在生成数据，请稍候..',
      background: 'rgba(0,0,0,0.5)'
    });
    download(condition, async (params, cb) => {
      try {
        const api = () => {
          if (type === 'publicPool') return myPublicCustomeList;
          else if (type === 'validPool') return getInvalidList;
          else if (type === 'blacklist') return getBlackList;
          else return getPrivateCustome
        }
        const res = await api()(params);
        if (!res.data || res.data.length <= 0) {
          Message.error('没有可导出的数据');
          return null;
        };
        const formatJson = (res.data || []).map(v => filterVal.map(j => {
          let value = v[j];
          if (['latest_follow_up_time', 'latest_distribution_time', 'put_in_time', 'distribute_at', 'created_at'].indexOf(j) >= 0) {
            value = parseTime(value, '{y}-{m}-{d} {h}:{i}');
          }
          return value;
        }))
        cb(formatJson, res.total);
        dispatch('downloadOprate', {type, params});
      } catch (error) {
        loadingInstance.close();
        console.log('錯誤了：', error)
        Message.error(error.msg || '导出列表出现错误');
      }
    }, {
      tHeader,
      name
    }, () => {
      loadingInstance.close();
    });
  },
  // 导出统计
  downloadOprate ({}, argument) {
    const {type, params} = argument;
    let url = defaultSetting.apiBaseURL;
    switch (type) {
      case "order":
        url += '/gateway/v1/order';
        break;
      case "publicPool":
        url += '/gateway/v1/customer/public-customer';
        break;
      case "validPool":
        url += '/gateway/v1/customer/invalid-customer';
        break;
      case "blacklist":
        url += '/gateway/v1/customer/black-customer';
        break;
      default:
        url += '/gateway/v1/customer/private-customer';
    }
    const data = Object.keys(params).map(v => `${v}=${params[v]}`).join('&');
    url += '?' + data;
    downloadCaculate({url});
  }
}
export default {
  namespaced: true,
  actions
}
